import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import { FolderNode } from './folder-node';
import { FolderDataSource } from './folder-data-source';
import { FolderSdk } from 'src/app/sdks/folder.sdk';
import { FolderResource } from 'src/app/models/resource/folder.resource';

@Component({
    selector: 'lex-folder-tree-view',
    templateUrl: './folder-tree-view.component.html',
    styleUrls: ['./folder-tree-view.component.scss'],
    standalone: false
})
export class FolderTreeViewComponent implements OnInit {
  @Output() clicked = new EventEmitter<FolderResource[]>();
  treeControl: FlatTreeControl<FolderNode>;
  dataSource: FolderDataSource;

  constructor(private folderService: FolderSdk) {
    this.treeControl = new FlatTreeControl<FolderNode>(this.getLevel, this.isExpandable);
    this.dataSource = new FolderDataSource(this.treeControl, folderService);
  }

  ngOnInit() {
    this.folderService.getRootFolder().subscribe(data => {
      const root = new FolderNode(data.value[0], 0);
      this.dataSource.data = [root];
      this.treeControl.expand(root); // Immediately expand the root (and load its children)
    });
  }

  getLevel = (node: FolderNode) => node.level;

  isExpandable = (node: FolderNode) => node.expandable;

  hasChild = (_: number, node: FolderNode) => node.expandable;

  folderClick(node: FolderNode) {
    this.dataSource.data.forEach(d => {
      d.selected = false;
    });
    node.selected = true;
    this.clicked.emit(this.dataSource.getPath(node));
  }
}
